module.exports = __webpack_public_path__ + "img/logo.52aaded8.webp";